import { render, staticRenderFns } from "./toggle23D.vue?vue&type=template&id=8e5c4f2e"
import script from "./toggle23D.vue?vue&type=script&lang=js"
export * from "./toggle23D.vue?vue&type=script&lang=js"
import style0 from "./toggle23D.vue?vue&type=style&index=0&id=8e5c4f2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports